import { on as f, off as o } from "../utils/dom/event.js";
var r = 0;
function d(t) {
  var i = "binded_" + r++;
  function e() {
    this[i] || (t.call(this, f, !0), this[i] = !0);
  }
  function n() {
    this[i] && (t.call(this, o, !1), this[i] = !1);
  }
  return {
    mounted: e,
    activated: e,
    deactivated: n,
    beforeDestroy: n
  };
}
export { d as BindEventMixin };
